<div class="relative h-full bg-slate-50/50 overflow-auto flex flex-col font-sans custom-scrollbar pb-20">

  <!------------------------------ Curved Header with Premium Gradient ------------------------------>
  <div
    class="absolute top-0 left-0 right-0 h-[220px] bg-(--background-color) rounded-b-[2.5rem] shadow-md z-0 transition-all duration-300">
  </div>

  <!---------------------------------------- Header Navigation & Title ---------------------------------->
  <div class="relative z-10 flex-none px-4 pt-4 pb-2">
    <div class="flex items-center justify-between">
      <button (click)="goback()" type="button"
        class="w-10 h-10 p-1 bg-white/95 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center text-slate-700 hover:opacity-90 active:scale-95 transition-all"
        aria-label="Go Back">
        <img src="icons/arrow_back_black.svg" class="w-full h-full" alt="back" />
      </button>
      <h1 class="text-lg font-extrabold text-(--main-color) tracking-wide">
        {{ currentLang === "TH" ? "ติดตามเรื่องของฉัน" : "My Support Cases" }}
      </h1>
      <div class="w-10"></div>
    </div>
  </div>

  <!---------------------------------------- Document Header Graphic ------------------------------>
  <div class="relative flex flex-col items-center pb-4 pt-1 z-10 flex-none">
    <div class="p-2 bg-white rounded-full shadow-lg shadow-gray-200/50 flex items-center justify-center">
      <div class="w-[72px] h-[72px] p-3.5 bg-white shadow rounded-full flex items-center justify-center">
        <img src="icons/alert_comment_yellow.png" alt="support" class="w-full h-full object-contain drop-shadow-sm" />
      </div>
    </div>
  </div>

  <!---------------------------------------- Main Scrollable Content Area ---------------------------------->
  <div class="relative z-10 flex-1 flex flex-col px-4 space-y-4 max-w-md mx-auto w-full">

    <!-------------------------------- Search Panel & Tab Switcher ---------------------------------->
    <div class="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl border border-slate-100/50 p-4 space-y-3">

      <!-- Quick Search Bar -->
      <div class="relative">
        <div
          class="relative flex items-center bg-slate-50/80 rounded-xl border border-slate-200 overflow-hidden text-slate-700 focus-within:border-(--main-color) focus-within:ring-2 focus-within:ring-(--main-color)/30 transition-all">
          <span class="pl-3 pr-1 text-slate-400 flex items-center">
            <img src="icons/search_black.svg" class="w-4 h-4 opacity-60" alt="search" />
          </span>
          <input type="text" [(ngModel)]="searchText"
            [placeholder]="currentLang === 'TH' ? 'ค้นหาเลขที่เรื่อง, หัวข้อ, หรือลานจอด...' : 'Search case no, subject, or site...'"
            class="w-full py-2 px-2 text-sm bg-transparent outline-none text-slate-800 placeholder:text-slate-400 font-sans" />
          <button *ngIf="searchText" (click)="searchText = ''" type="button"
            class="pr-3 text-slate-400 hover:text-slate-600 transition-colors flex items-center">
            <img src="icons/close_slate.svg" class="w-4 h-4" alt="clear" />
          </button>
        </div>
      </div>

      <!-- Segmented Tab Buttons -->
      <div class="grid grid-cols-2 gap-2 text-xs font-bold pt-1">
        <button (click)="switchTab('active')" type="button" [ngClass]="activeTab === 'active' 
                    ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' 
                    : 'bg-slate-100/80 text-slate-600 hover:text-slate-900 border border-slate-200/50'"
          class="py-2.5 rounded-xl text-center transition-all duration-200 flex items-center justify-center gap-1.5 active:scale-95">
          <span>{{ currentLang === 'TH' ? 'กำลังดำเนินการ' : 'In Progress' }}</span>
          <span [ngClass]="activeTab === 'active' ? 'bg-white/80 text-slate-900' : 'bg-slate-200 text-slate-600'"
            class="px-2 py-0.5 text-[11px] rounded-full">
            {{ activeCases.length }}
          </span>
        </button>

        <button (click)="switchTab('history')" type="button" [ngClass]="activeTab === 'history' 
                    ? 'bg-(--main-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' 
                    : 'bg-slate-100/80 text-slate-600 hover:text-slate-900 border border-slate-200/50'"
          class="py-2.5 rounded-xl text-center transition-all duration-200 flex items-center justify-center gap-1.5 active:scale-95">
          <span>{{ currentLang === 'TH' ? 'ประวัติ' : 'History' }}</span>
          <span [ngClass]="activeTab === 'history' ? 'bg-white/80 text-slate-900' : 'bg-slate-200 text-slate-600'"
            class="px-2 py-0.5 text-[11px] rounded-full">
            {{ historyCases.length }}
          </span>
        </button>
      </div>

    </div>

    <!-------------------------------- Empty State ---------------------------------->
    <div *ngIf="displayedCases.length === 0"
      class="bg-white/95 backdrop-blur-sm rounded-2xl p-8 text-center border border-slate-100/50 shadow-xl mt-2">
      <div class="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-3 shadow-inner">
        <img src="icons/Parking-history/doccument.png" alt="empty" class="w-8 h-8 opacity-60" />
      </div>
      <p class="text-sm font-bold text-slate-700">
        {{ currentLang === 'TH' ? 'ไม่มีรายการเรื่องแจ้ง' : 'No service cases found' }}
      </p>
      <p class="text-xs text-slate-400 mt-1">
        {{ currentLang === 'TH' ? 'ไม่พบรายการเรื่องในหมวดหมู่นี้' : 'There are no items matching your criteria.' }}
      </p>
    </div>

    <!-------------------------------- Case Cards List ---------------------------------->
    <div class="space-y-3">
      <div *ngFor="let item of displayedCases" (click)="openCaseDetail(item.id)"
        class="group relative bg-white/95 backdrop-blur-sm border border-slate-100/50 rounded-2xl p-4 shadow-xl hover:shadow-2xl active:scale-[0.99] transition-all duration-200 cursor-pointer overflow-hidden">

        <!-- Status & Date Header -->
        <div class="flex items-center justify-between gap-2 mb-2">
          <span
            [class]="'px-3 py-0.5 text-xs font-semibold rounded-full border border-slate-200/60 flex items-center gap-1.5 ' + getStatusBadgeClass(item.status)">
            <span class="w-1.5 h-1.5 rounded-full bg-current"></span>
            <span>{{ item.statusLabel || item.status }}</span>
          </span>

          <span *ngIf="item.createDate" class="text-xs text-slate-400 font-light flex items-center gap-1">
            <img src="icons/calendar_month_slate.svg" class="w-3.5 h-3.5 opacity-60" alt="date" />
            <span>{{ item.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
          </span>
        </div>

        <!-- Case Subject & Case No -->
        <div class="mb-2 pr-6">
          <h3 class="text-sm font-extrabold text-slate-800 group-hover:text-amber-600 transition-colors line-clamp-1">
            {{ item.subject || item.issueTypeName }}
          </h3>
          <p class="text-xs text-slate-400 font-mono mt-0.5">
            {{ item.caseNo }}
          </p>
        </div>

        <!-- Meta Details (Site & Issue Type) -->
        <div class="flex flex-wrap items-center gap-3 pt-2.5 border-t border-slate-100 text-xs text-slate-500">
          <div *ngIf="item.siteName" class="flex items-center gap-1">
            <img src="icons/place_slate.svg" class="w-3.5 h-3.5 opacity-70" alt="site" />
            <span class="truncate max-w-[160px]">{{ item.siteName }}</span>
          </div>

          <div *ngIf="item.issueTypeName" class="flex items-center gap-1">
            <img src="icons/badge_slate.svg" class="w-3.5 h-3.5 opacity-70" alt="type" />
            <span>{{ item.issueTypeName }}</span>
          </div>
        </div>

        <!-- Right Chevron Arrow -->
        <div
          class="absolute right-4 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-slate-50 group-hover:bg-amber-400 group-hover:text-slate-900 text-slate-400 flex items-center justify-center transition-all shadow-sm">
          <img src="icons/chevron_right_orange.svg" class="w-4 h-4" alt="arrow" />
        </div>
      </div>
    </div>

  </div>
</div>

<!-------------------------------- Glassmorphic Case Detail Modal Overlay ---------------------------------->
<div *ngIf="showDetailModal && selectedCaseDetail"
  class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/60 backdrop-blur-sm p-0 sm:p-4 transition-opacity duration-200">

  <div
    class="bg-white rounded-t-[2.5rem] sm:rounded-[2.5rem] w-full max-w-lg max-h-[88vh] flex flex-col shadow-2xl overflow-hidden border border-slate-100/50 animate-fade-in-up">

    <!-- Modal Title Bar Header -->
    <div
      class="p-4 border-b border-slate-100 flex items-center justify-between bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800">
      <div class="flex items-center gap-2.5">
        <div
          class="w-10 h-10 p-2 bg-white/90 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center shrink-0">
          <img src="icons/alert_comment_yellow.png" alt="icon" class="w-full h-full object-contain" />
        </div>
        <div>
          <h2 class="text-sm font-extrabold text-slate-800 line-clamp-1">
            {{ selectedCaseDetail.subject || selectedCaseDetail.issueTypeName }}
          </h2>
          <p class="text-xs text-slate-700/80 font-mono">
            {{ selectedCaseDetail.caseNo }}
          </p>
        </div>
      </div>

      <button (click)="closeDetailModal()" type="button"
        class="w-8 h-8 rounded-full bg-white/80 hover:bg-white text-slate-700 flex items-center justify-center transition-colors shadow-sm shrink-0">
        <img src="icons/close_black.svg" class="w-4 h-4" alt="close" />
      </button>
    </div>

    <!-- Modal Content Body -->
    <div class="p-4 overflow-y-auto space-y-4 text-sm custom-scrollbar flex-1 bg-slate-50/30">

      <!-- Status Badge & Date Banner -->
      <div class="bg-white rounded-2xl p-3.5 border border-slate-100 shadow-sm flex items-center justify-between">
        <div>
          <span class="text-xs text-slate-400 block mb-1 font-semibold">
            {{ currentLang === 'TH' ? 'สถานะปัจจุบัน' : 'Current Status' }}
          </span>
          <span
            [class]="'px-3 py-0.5 text-xs font-bold rounded-full border inline-block ' + getStatusBadgeClass(selectedCaseDetail.status)">
            {{ selectedCaseDetail.statusLabel || selectedCaseDetail.status }}
          </span>
        </div>

        <div class="text-right">
          <span class="text-xs text-slate-400 block mb-1 font-semibold">
            {{ currentLang === 'TH' ? 'วันที่เปิดเรื่อง' : 'Created Date' }}
          </span>
          <span class="text-xs font-medium text-slate-700 flex items-center gap-1 justify-end">
            <img src="icons/calendar_month_slate.svg" class="w-3.5 h-3.5 opacity-60" alt="date" />
            <span>{{ selectedCaseDetail.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
          </span>
        </div>
      </div>

      <!-- Detail Info Grid (Site & Issue Type) -->
      <div class="bg-white rounded-2xl p-3.5 border border-slate-100 shadow-sm space-y-2 text-xs">
        <div *ngIf="selectedCaseDetail.siteName" class="flex items-center justify-between">
          <span class="text-slate-400 flex items-center gap-1">
            <img src="icons/place_slate.svg" class="w-3.5 h-3.5 opacity-70" alt="site" />
            <span>{{ currentLang === 'TH' ? 'สถานที่/ลานจอด:' : 'Parking Location:' }}</span>
          </span>
          <span class="font-bold text-slate-700">{{ selectedCaseDetail.siteName }}</span>
        </div>

        <div *ngIf="selectedCaseDetail.issueTypeName"
          class="flex items-center justify-between pt-2 border-t border-slate-50">
          <span class="text-slate-400 flex items-center gap-1">
            <img src="icons/badge_slate.svg" class="w-3.5 h-3.5 opacity-70" alt="type" />
            <span>{{ currentLang === 'TH' ? 'หมวดหมู่ปัญหา:' : 'Category:' }}</span>
          </span>
          <span class="font-bold text-slate-700">{{ selectedCaseDetail.issueTypeName }}</span>
        </div>
      </div>

      <!-- Issue Description Box -->
      <div *ngIf="selectedCaseDetail.description" class="bg-white rounded-2xl p-3.5 border border-slate-100 shadow-sm">
        <h4 class="text-xs font-bold text-slate-500 mb-1.5 flex items-center gap-1.5">
          <img src="icons/edit_note_orange.svg" class="w-4 h-4" alt="desc" />
          <span>{{ currentLang === 'TH' ? 'รายละเอียดเรื่อง' : 'Description' }}</span>
        </h4>
        <p
          class="text-sm text-slate-700 leading-relaxed font-light whitespace-pre-line bg-slate-50/50 p-2.5 rounded-xl border border-slate-100">
          {{ selectedCaseDetail.description }}
        </p>
      </div>

      <!-- Customer Status Note / Resolution / Cancel Reason -->
      <div
        *ngIf="selectedCaseDetail.customerStatusNote || selectedCaseDetail.resolutionSummary || selectedCaseDetail.cancelReason"
        class="space-y-2">
        <div *ngIf="selectedCaseDetail.customerStatusNote"
          class="bg-blue-50/80 border border-blue-100 rounded-2xl p-3 text-xs text-blue-900">
          <strong class="font-bold block mb-0.5">{{ currentLang === 'TH' ? 'หมายเหตุสถานะ:' : 'Status Note:' }}</strong>
          {{ selectedCaseDetail.customerStatusNote }}
        </div>

        <div *ngIf="selectedCaseDetail.resolutionSummary"
          class="bg-emerald-50/80 border border-emerald-100 rounded-2xl p-3 text-xs text-emerald-900">
          <strong class="font-bold block mb-0.5">{{ currentLang === 'TH' ? 'สรุปผลการดำเนินการ:' : 'Resolution Summary:'
            }}</strong>
          {{ selectedCaseDetail.resolutionSummary }}
        </div>

        <div *ngIf="selectedCaseDetail.cancelReason"
          class="bg-rose-50/80 border border-rose-100 rounded-2xl p-3 text-xs text-rose-900">
          <strong class="font-bold block mb-0.5">{{ currentLang === 'TH' ? 'เหตุผลที่ยกเลิก:' : 'Cancellation Reason:'
            }}</strong>
          {{ selectedCaseDetail.cancelReason }}
        </div>
      </div>

      <!-- Timeline Progress Section -->
      <div class="bg-white rounded-2xl p-4 border border-slate-100 shadow-sm">
        <h4 class="text-xs font-extrabold text-slate-800 mb-3 flex items-center gap-1.5">
          <img src="icons/schedule_orange.svg" class="w-4 h-4" alt="timeline" />
          <span>{{ currentLang === 'TH' ? 'ประวัติการดำเนินการ (Timeline)' : 'Timeline Progress' }}</span>
        </h4>

        <div *ngIf="selectedCaseDetail.timeline.length === 0" class="text-xs text-slate-400 italic text-center py-4">
          {{ currentLang === 'TH' ? 'ยังไม่มีประวัติการดำเนินการ' : 'No timeline history available.' }}
        </div>

        <div *ngIf="selectedCaseDetail.timeline.length > 0"
          class="relative pl-6 space-y-4 border-l-2 border-amber-200/70 ml-2 pt-1">
          <div *ngFor="let log of selectedCaseDetail.timeline; let last = last" class="relative group">

            <!-- Timeline Circle Bullet -->
            <div [ngClass]="last ? 'bg-(--main-color) ring-4 ring-(--main-color)/20' : 'bg-slate-300'"
              class="absolute -left-[31px] top-0.5 w-4 h-4 rounded-full border-2 border-white shadow-sm transition-all">
            </div>

            <!-- Log Card -->
            <div class="bg-slate-50/90 rounded-xl p-3 border border-slate-100 text-xs space-y-1">
              <div class="flex items-center justify-between text-slate-400 text-[11px]">
                <span class="font-bold text-slate-700">
                  {{ log.actorUserName || (currentLang === 'TH' ? 'เจ้าหน้าที่ Call Center' : 'Support Staff') }}
                </span>
                <span>{{ log.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>

              <p class="text-slate-800 font-normal leading-relaxed pt-0.5">
                {{ log.message }}
              </p>

              <div *ngIf="log.attachmentUrl" class="pt-1">
                <a [href]="log.attachmentUrl" target="_blank"
                  class="inline-flex items-center gap-1 text-amber-600 hover:underline">
                  <img src="icons/info_slate.svg" class="w-3.5 h-3.5" alt="attachment" />
                  <span>{{ currentLang === 'TH' ? 'ดูไฟล์แนบ' : 'View Attachment' }}</span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- Modal Footer Close Button -->
    <div class="p-3 border-t border-slate-100 bg-white flex justify-center">
      <button (click)="closeDetailModal()" type="button"
        class="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-xs rounded-xl active:scale-95 transition-all text-center">
        {{ currentLang === 'TH' ? 'ปิดหน้าต่าง' : 'Close' }}
      </button>
    </div>

  </div>
</div>

<!-------------------------------- Loading Overlay Outside Main Container ---------------------------------->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>